import React from 'react';
import {
    DoppeActionTypeWidgetInnerButton
} from '../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {OmitStrict} from '@wix/devzai-utils-common';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {
    DoppeActionCTAButtonMultiple,
    DoppeActionCTAButtonSingle,
    DoppeActionCTAType,
    DoppeActionSettingsCTAButtonSettings
} from '../../client-server-common/types/doppe-action-cta-button';
import {DoppeActionGoalType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage
} from './doppe-action-type-widget-inner-link-type-cta-button-types/doppe-action-type-widget-inner-link-type-cta-button-open-page/doppe-action-type-widget-inner-link-type-cta-button-open-page';
import {
    DoppeActionTypeWidgetInnerLinkTypeCtaButtonCommon
} from './doppe-action-type-widget-inner-link-type-cta-button-types/doppe-action-type-widget-inner-link-type-cta-button-common/doppe-action-type-widget-inner-link-type-cta-button-common';

export const DoppeActionTypeWidgetInnerLinkTypeCtaButton = React.memo(function DoppeActionTypeWidgetInnerLinkTypeCtaButton(props: DoppeActionTypeWidgetInnerLinkTypeCtaButton.Props) {
    switch (props.ctaButton.settings.type) {
        case DoppeActionCTAType.OpenPage:
            return (
                <DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage
                    {...props}
                />
            );
        default:
            return (
                <DoppeActionTypeWidgetInnerLinkTypeCtaButtonCommon
                    {...props}
                />
            );
    }
});

export namespace DoppeActionTypeWidgetInnerLinkTypeCtaButton {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetInnerButton.Props, 'suffixIcon' | 'target' | 'href' | 'tagName' | 'children' | 'onClick'> {
        actionContext: IDoppeViewerActionContext<any>;
        ctaButton: DoppeActionCTAButtonSingle | DoppeActionCTAButtonMultiple;
        sourceURL?: string;
        ctaCallback?: (settings: DoppeActionSettingsCTAButtonSettings) => void;
        onClick: (goalType: DoppeActionGoalType) => void;
        listItemId?: string;
    }

}
